<template>
  <div>
    <v-textarea rows="2"
                dark
                rounded
                outlined
                solo
                class="chat-input"
                background-color="secondary"
                color="primary"
                v-model="message"
                auto-grow
                @keypress.enter.exact.prevent="submit"
                hide-details>
      <template v-slot:append>
        <v-btn @click="submit" :loading="loading" class="mb-4" icon small color="white"><v-icon small>mdi mdi-send</v-icon></v-btn>
      </template>
      <template v-slot:append-outer v-if="$vuetify.breakpoint.mdAndDown">
        <v-menu v-model="optionsMenu" top left>
          <template v-slot:activator="{on, attrs}">
            <v-btn v-on="on" v-bind="attrs" icon small color="primary"><v-icon>mdi mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense :class="$vuetify.breakpoint.smAndUp && 'py-0'">
            <v-list-item @click="startNewChat">
              <v-list-item-action><v-icon>mdi mdi-chat-plus-outline</v-icon></v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Aloita uusi keskustelu</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <template v-if="$vuetify.breakpoint.xsOnly">
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-title class="subtitle-2">
                  Valitse keskustelun tyyli:
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-for="temperature in temperatures" :key="temperature.value" @click="changeTemperature(temperature.value)">
                <v-list-item-icon>
                  <v-icon v-if="temperature.value === adjustTemperature" color="accent">mdi mdi-checkbox-blank-circle</v-icon>
                  <v-icon v-else color="grey">mdi mdi-checkbox-blank-circle-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ temperature.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
    </v-textarea>
  </div>
</template>

<script>
export default {
  name: "ChatInput",
  props: ['temperature', 'loading'],
  data() {
    return {
      message: '',
      optionsMenu: false,
      temperatures: [
        {value: 20, text: 'Tarkempi'},
        {value: 50, text: 'Tasapainoisempi'},
        {value: 100, text: 'Luovempi'}
      ]
    }
  },
  computed: {
    adjustTemperature: {
      get() {
        return this.temperature;
      },
      set(value) {
        this.$emit('temperature', value)
      }
    }
  },
  methods: {
    changeTemperature(value) {
      this.adjustTemperature = value;
    },
    submit() {
      if (this.message.length === 0) return;
      this.$emit('submit', this.message)
      this.message = '';
    },
    startNewChat() {
      this.$emit('start-new-chat');
    }
  }
}
</script>

<style lang="scss">
.chat-input {
  .v-input__append-inner {
    align-self: end !important;
  }
}
</style>
